import TikTok from "@/pixels/providers/tikTok";
import Vue from "vue";

describe("TikTok config", () => {
  beforeEach(() => {
    jest.spyOn(TikTok, "enable");
    jest.spyOn(TikTok, "wait");
    jest.spyOn(TikTok, "consulta");
    jest.spyOn(TikTok, "oferta");
    jest.spyOn(TikTok, "paso1");
    jest.spyOn(TikTok, "paso2");
    jest.spyOn(TikTok, "paso3");
    jest.spyOn(TikTok, "paso4");
    jest.spyOn(TikTok, "thank");
    jest.spyOn(TikTok, "noCliente");
    jest.spyOn(TikTok, "cliente");
    jest.spyOn(TikTok, "graciasCajaAhorro");
    document.createElement = jest.fn(() => ({
      addEventListener: jest.fn()
    }));
    document.getElementsByTagName = jest.fn(() => [
      {
        appendChild: jest.fn(),
        parentNode: {
          insertBefore: jest.fn()
        }
      }
    ]);
    Vue.$log = {
      info: jest.fn()
    };
  });
  it("configuracion exportada por defecto", () => {
    expect(TikTok).toBeDefined();
    expect(TikTok).not.toBeNull();
  });

  it("configuracion por defecto para Enable", () => {
    TikTok.enable();
    const enableMock = jest.spyOn(TikTok, "enable");
    expect(enableMock).toHaveBeenCalledTimes(1);
  });

  it("configuracion por defecto para Wait", () => {
    TikTok.wait();
    const waitMock = jest.spyOn(TikTok, "wait");
    expect(waitMock).toHaveBeenCalledTimes(1);
  });

  it("configuracion por defecto para los pasos", () => {
    TikTok.consulta();
    const consultaMock = jest.spyOn(TikTok, "consulta");
    expect(consultaMock).toHaveBeenCalledTimes(1);

    TikTok.oferta();
    const ofertaMock = jest.spyOn(TikTok, "oferta");
    expect(ofertaMock).toHaveBeenCalledTimes(1);

    TikTok.paso1();
    const paso1Mock = jest.spyOn(TikTok, "paso1");
    expect(paso1Mock).toHaveBeenCalledTimes(1);

    TikTok.paso2();
    const paso2Mock = jest.spyOn(TikTok, "paso2");
    expect(paso2Mock).toHaveBeenCalledTimes(1);

    TikTok.paso3();
    const paso3Mock = jest.spyOn(TikTok, "paso3");
    expect(paso3Mock).toHaveBeenCalledTimes(1);

    TikTok.paso4();
    const paso4Mock = jest.spyOn(TikTok, "paso4");
    expect(paso4Mock).toHaveBeenCalledTimes(1);

    TikTok.thank();
    const thankMock = jest.spyOn(TikTok, "thank");
    expect(thankMock).toHaveBeenCalledTimes(1);

    TikTok.noCliente();
    const noClienteMock = jest.spyOn(TikTok, "noCliente");
    expect(noClienteMock).toHaveBeenCalledTimes(1);

    TikTok.cliente();
    const clienteMock = jest.spyOn(TikTok, "cliente");
    expect(clienteMock).toHaveBeenCalledTimes(1);

    TikTok.graciasCajaAhorro();
    const graciasCajaAhorroMock = jest.spyOn(TikTok, "graciasCajaAhorro");
    expect(graciasCajaAhorroMock).toHaveBeenCalledTimes(1);
  });
});
